import { useEffect, useRef, useState } from 'react';

/**
 * Shows `value`, and gives it a short pop each time it changes after the
 * first render, so a count that moves catches the eye. Nothing moves on
 * mount, nor under reduced motion.
 */
const PopOnChange = ({ value, className = '' }) => {
  const [popCount, setPopCount] = useState(0);
  // The previous value rather than a first-render flag: StrictMode runs the
  // mount effect twice, and a flag would pop the count on mount.
  const previousValue = useRef(value);

  useEffect(() => {
    if (Object.is(previousValue.current, value)) return;
    previousValue.current = value;
    setPopCount((count) => count + 1);
  }, [value]);

  return (
    <span
      // A new key restarts the animation; the span holds nothing but text.
      key={popCount}
      className={`inline-block ${
        popCount > 0 ? 'motion-safe:animate-countPop' : ''
      } ${className}`}
    >
      {value}
    </span>
  );
};

export default PopOnChange;
